module.exports = __webpack_public_path__ + "static/media/e-com_m1.96434e79.png";